export function initLoginTabs() {
    for (const tablist of document.querySelectorAll('.loginTabs[role="tablist"]')) {
        const tabs = tablist.querySelectorAll('[role="tab"]');

        function activateTab(tab) {
            for (const t of tabs) {
                t.setAttribute('aria-selected', 'false');
                t.setAttribute('tabindex', '-1');
                t.classList.remove('is-active');
                const panel = document.getElementById(t.getAttribute('aria-controls'));
                if (panel) panel.hidden = true;
            }
            tab.setAttribute('aria-selected', 'true');
            tab.setAttribute('tabindex', '0');
            tab.classList.add('is-active');
            const activePanel = document.getElementById(tab.getAttribute('aria-controls'));
            if (activePanel) activePanel.hidden = false;
        }

        for (const tab of tabs) {
            tab.addEventListener('click', function () {
                activateTab(tab);
            });

            tab.addEventListener('keydown', function (e) {
                const tabArray = Array.from(tabs);
                const index = tabArray.indexOf(tab);
                if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                    e.preventDefault();
                    const next = tabArray[(index + 1) % tabArray.length];
                    activateTab(next);
                    next.focus();
                } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                    e.preventDefault();
                    const prev = tabArray[(index - 1 + tabArray.length) % tabArray.length];
                    activateTab(prev);
                    prev.focus();
                } else if (e.key === 'Home') {
                    e.preventDefault();
                    activateTab(tabArray[0]);
                    tabArray[0].focus();
                } else if (e.key === 'End') {
                    e.preventDefault();
                    activateTab(tabArray[tabArray.length - 1]);
                    tabArray[tabArray.length - 1].focus();
                }
            });
        }
    }
}
